import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UiState } from 'features/app-info/types';
import { isHEXColor } from 'utils/dataTypes/string';

const initialState: UiState = {
  isListView: true,
  isSidebarCollapsed: false,
  selectedMenuKeys: [],
  selectedOpenKeys: [],
  fullContentView: false,
  appPrimaryColor: '#079669',
  darkMode: false,
};

const appUISlice = createSlice({
  name: 'appInfo',
  initialState,
  reducers: {
    setSelectedMenuKeys(state, action: PayloadAction<string[]>) {
      state.selectedMenuKeys = action.payload;
    },

    setSelectedOpenKeys(state, action: PayloadAction<string[]>) {
      state.selectedOpenKeys = action.payload;
    },

    setAppPrimaryColor(state, action: PayloadAction<string>) {
      if (!isHEXColor(action.payload)) return;
      state.appPrimaryColor = action.payload;
    },

    setDarkMode(state, action: PayloadAction<boolean>) {
      state.darkMode = action.payload;
      localStorage.setItem('darkMode', JSON.stringify(action.payload));
      !action.payload
        ? document.documentElement.classList.remove('dark')
        : document.documentElement.classList.add('dark');
    },
  },
});

export const { setSelectedMenuKeys, setSelectedOpenKeys, setDarkMode } =
  appUISlice.actions;
export default appUISlice.reducer;
